import { render, staticRenderFns } from "./ManageSubjects.vue?vue&type=template&id=130e30c5&"
import script from "./ManageSubjects.vue?vue&type=script&lang=js&"
export * from "./ManageSubjects.vue?vue&type=script&lang=js&"
import style0 from "./ManageSubjects.vue?vue&type=style&index=0&id=130e30c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports